import type { CatalogItem } from '~/models/common'

export const gameGenres: CatalogItem[] = [
  {
    label: 'Action',
    value: 1,
  },
  {
    label: 'Adventure',
    value: 21,
  },
  {
    label: 'Arcade / Bullet Hell / Twin-Stick',
    value: 2,
  },
  {
    label: 'Base / City Building',
    value: 83,
  },
  {
    label: 'Betting / Casino / Poker',
    value: 112,
  },
  {
    label: 'Board / Card',
    value: 43,
  },
  {
    label: 'Brawler / Hack and Slash',
    value: 3,
  },
  {
    label: 'Casual',
    value: 44,
  },
  {
    label: 'Crafting / Farming',
    value: 109,
  },
  {
    label: 'Educational',
    value: 28,
  },
  {
    label: 'Fighting',
    value: 4,
  },
  {
    label: 'Gambling',
    value: 76,
  },
  {
    label: 'Horror',
    value: 104,
  },
  {
    label: 'Hypercasual',
    value: 32,
  },
  {
    label: 'Idle / Clicker',
    value: 41,
  },
  {
    label: 'Management / Tycoon',
    value: 87,
  },
  {
    label: 'Match-3',
    value: 48,
  },
  {
    label: 'Metroidvania',
    value: 19,
  },
  {
    label: 'Open World',
    value: 110,
  },
  {
    label: 'Platformer',
    value: 9,
  },
  {
    label: 'Point & Click / Visual Novel',
    value: 24,
  },
  {
    label: 'Puzzle',
    value: 42,
  },
  {
    label: 'Racing / Runner',
    value: 55,
  },
  {
    label: 'Rhytm / Music',
    value: 10,
  },
  {
    label: 'Roguelike / Soulslike',
    value: 65,
  },
  {
    label: 'RPG',
    value: 96,
  },
  {
    label: 'Sandbox',
    value: 111,
  },
  {
    label: 'Shooter',
    value: 97,
  },
  {
    label: 'Simulation',
    value: 68,
  },
  {
    label: 'Sports',
    value: 77,
  },
  {
    label: 'Stealth',
    value: 13,
  },
  {
    label: 'Strategy',
    value: 80,
  },
  {
    label: 'Survival',
    value: 14,
  },
  {
    label: 'Tower Defense',
    value: 90,
  },
  {
    label: 'Trivia / Word',
    value: 53,
  },
  {
    label: 'Turn-Based',
    value: 67,
  },
]
